export default __webpack_public_path__ + "images/4_Tilbud_kuponger.webp";